import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }

import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@/styles/global.scss'

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { firestore as db, storage } from '@/main'
import { onMounted, ref, computed, watch } from 'vue'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore'
import { getDownloadURL, ref as storageRef, uploadBytes } from 'firebase/storage'
import { CommonBoardCreateRequest } from '@/types/CommonBoardItem'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePostView',
  setup(__props) {

const panel = ref([0])
const selectedFile = ref<File|null>(null)
const showProgress = ref(false)
const contents = ref<Delta|undefined>(undefined)
const isEditMode = ref(false)
const isPrivate = ref(false)
const selectedCategory = ref('Awards')

const postData = ref<CommonBoardCreateRequest>({
  contents: '',
  date: '',
  title: ''
})

const categories = [
  'Awards', 'Downloads', 'Gallery', 'News'
]

const fileAccept = computed(() => selectedCategory.value.includes('Downloads') ? '' : 'image/*')

async function upload () {
  if (postData.value.title === '' || contents.value === undefined || (!isEditMode.value && selectedFile.value === null)) {
    alert('Please fill in all required fields.')
  } else {
    showProgress.value = true

    postData.value.contents = contents.value === undefined ? '' : JSON.stringify(contents.value)
    let docId = ''

    if (isEditMode.value) {
      docId = history.state.post.id

      await updateDoc(
        doc(db, selectedCategory.value, (docId)), {
          ...(postData.value)
        }
      )
        .catch((e: Error) => {
          alert(`An error occurred while modifying post.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })
    } else {
      postData.value.date = `${new Date().getFullYear()}.${String(new Date().getMonth() + 1).padStart(2, '0')}.${String(new Date().getDate()).padStart(2, '0')} ${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`
      const docRef = await addDoc(
        collection(db, selectedCategory.value), {
          ...(postData.value)
        }
      )
        .catch((e: Error) => {
          alert(`An error occurred while creating a new post.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })

      docId = docRef.id
    }

    if (selectedFile.value !== null) {
      const uploadRef = storageRef(
        storage,
        selectedCategory.value.includes('Downloads')
          ? `${selectedCategory.value.toLocaleLowerCase()}/${selectedFile.value.name}`
          : `${selectedCategory.value.toLowerCase()}/img/${docId}.${selectedFile.value.name.split('.').pop()}`
      )

      uploadBytes(uploadRef, selectedFile.value)
        .catch((e: Error) => {
          alert(`An error occurred while uploading file.\nPlease try again later.\n(${e.message})`)
          showProgress.value = false
        })
        .then(() => {
          getDownloadURL(uploadRef)
            .then((url) => {
              updateDoc(doc(db, selectedCategory.value, docId), { [selectedCategory.value.includes('Downloads') ? 'file' : 'image']: url })
                .catch((e: Error) => {
                  alert(`An error occurred while saving file URL.\nPlease try again later.\n(${e.message})`)
                })
                .then(() => {
                  alert(isEditMode.value ? 'Post modified successfully.' : 'New post created successfully.')
                  router.back()
                })
                .finally(() => {
                  showProgress.value = false
                })
            })
            .catch((e: Error) => {
              alert(`An error occurred while retrieving image URL.\nPlease try again later.\n(${e.message})`)
              showProgress.value = false
            })
        })
    } else {
      alert(isEditMode.value ? 'Post modified successfully.' : 'New post created successfully.')
      showProgress.value = false
      router.back()
    }
  }
}

watch(isPrivate, () => {
  if (!isEditMode.value && (selectedCategory.value === 'Downloads' || selectedCategory.value === 'Private_Downloads')) {
    selectedCategory.value = isPrivate.value ? 'Private_Downloads' : 'Downloads'
  }
})

watch(selectedCategory, () => {
  if (!isEditMode.value && selectedCategory.value !== 'Private_Downloads') {
    isPrivate.value = false
  }

  if (selectedCategory.value !== 'Private_Downloads' && selectedCategory.value !== 'Downloads') {
    selectedFile.value = null
  }
})

onMounted(() => {
  if (history.state.post) {
    console.log(history.state.post)
    isEditMode.value = true
    postData.value = { ...(history.state.post as CommonBoardCreateRequest) }
    contents.value = postData.value.contents ? new Delta(JSON.parse(history.state.post.contents)) : undefined
    selectedCategory.value = history.state.post.category
  } else {
    if (history.state.back === '/awards') {
      selectedCategory.value = 'Awards'
    } else if (history.state.back === '/gallery') {
      selectedCategory.value = 'Gallery'
    } else if (history.state.back === '/news') {
      selectedCategory.value = 'News'
    } else if (history.state.back === '/downloads') {
      selectedCategory.value = 'Downloads'
    } else {
      alert('Invalid access.')
      router.back()
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: isEditMode.value ? 'Modify Post' : 'Create New Post',
              "leading-icon": 'fa-solid fa-chevron-left',
              "show-leading-btn": true,
              "trailing-icon": 'fa-solid fa-check',
              "show-progress": showProgress.value,
              onOnClick: upload,
              onOnLeadingBtnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }, null, 8, ["title", "show-progress"])
          ]),
          _createVNode(_component_v_expansion_panels, {
            modelValue: panel.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((panel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel, {
                title: "Required Informations",
                class: "rounded-xl",
                expand: "",
                "expand-icon": 
              postData.value.title !== '' && contents.value !== undefined
                ? 'mdi-check'
                : 'mdi-chevron-down'
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_text_field, {
                          variant: "solo-filled",
                          color: "primary",
                          modelValue: postData.value.title,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((postData.value.title) = $event)),
                          label: "Title",
                          "prepend-inner-icon": "mdi-format-title",
                          "clear-icon": "mdi-close",
                          clearable: "",
                          "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (postData.value.title = ''))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_select, {
                          disabled: isEditMode.value,
                          variant: "solo-filled",
                          modelValue: selectedCategory.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCategory).value = $event)),
                          items: categories,
                          label: "Category",
                          "prepend-inner-icon": "mdi-shape",
                          "item-title": "text",
                          "item-value": "value",
                          color: "primary"
                        }, null, 8, ["disabled", "modelValue"]),
                        _createVNode(_component_v_file_input, {
                          modelValue: selectedFile.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedFile).value = $event)),
                          "prepend-icon": selectedCategory.value.includes('Downloads') ? 'mdi-file' : 'mdi-image',
                          label: isEditMode.value ? `Change ${selectedCategory.value.includes('Downloads') ? 'File' : 'Image'}` : `${selectedCategory.value.includes('Downloads') ? 'File' : 'Image'}`,
                          accept: fileAccept.value,
                          variant: "solo-filled"
                        }, null, 8, ["modelValue", "prepend-icon", "label", "accept"]),
                        (selectedCategory.value.includes('Downloads') && !isEditMode.value)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 0,
                              modelValue: isPrivate.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isPrivate).value = $event)),
                              label: "Private (Only visible to signed-in users)",
                              "prepend-icon": "mdi-eye-off",
                              color: "primary"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(QuillEditor), {
                          placeholder: "Contents",
                          content: contents.value,
                          "onUpdate:content": _cache[6] || (_cache[6] = ($event: any) => ((contents).value = $event)),
                          theme: "snow",
                          toolbar: "full"
                        }, null, 8, ["content"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["expand-icon"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})